import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EntityOp } from '@ngrx/data';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastr = inject(ToastrService);

  /**
   * @param message
   * @param action
   */
  showSuccess(message: any, action: any) {
    this.toastr.success(action, 'Success');
  }
  /**
   * @param message
   * @param action
   */
  showWarn(message: any, action: any) {
    this.toastr.warning(action, 'Warn');
  }
  /**
   * @param message
   * @param action
   */
  showError(message: any, action: any) {
    this.toastr.error(message, action);
  }
  /**
   * @param message
   * @param title
   */
  showInfo(message: any, title: any) {
    this.toastr.info(message, title);
  }
  /**
   * @param message
   * @param action
   * @param entityAction
   */
  openSnackBar(message: string, action: string, entityAction?: any) {
    switch (action) {
      case EntityOp.SAVE_ADD_ONE_SUCCESS:
        this.showSuccess(message, 'Succesfully created');
        break;

      case EntityOp.SAVE_UPDATE_ONE_SUCCESS:
        this.showSuccess(message, 'Succesfully updated');
        break;

      default:
        if (action.includes('error')) {
          this.showError(
            `${entityAction.payload.data.error.error.status}  
            ${entityAction.payload.data.error.error.statusText}`,
            entityAction.payload.data.error.error.error.title,
          );
        }
        break;
    }
  }
}
